// Jurisdictions and authorities route (/admin/datasets/registry): the kind shown in the URL; the screen is RegistryPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { enumWithDefault } from "@/app/search";
import { RegistryPage } from "@/features/datasets/RegistryPage";

const REGISTRY_KINDS = ["jurisdictions", "authorities"] as const;

const searchSchema = z.object({
  kind: enumWithDefault(REGISTRY_KINDS, "jurisdictions"),
});

export const Route = createFileRoute("/_app/admin/datasets/registry")({
  validateSearch: searchSchema,
  staticData: { crumb: "Jurisdictions & authorities" },
  component: RegistryPage,
});
